var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg035FirstAidCross = function Svg035FirstAidCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M271 211h-30v60h-60v30h60v60h30v-60h60v-30h-60z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M361 91V31H151v60H68.789L0 159.789v252.422L68.789 481h374.422L512 412.211V159.789L443.211 91zM181 61h150v30H181zm180 270h-60v60h-90v-60h-60v-90h60v-60h90v60h60z"
  })));
};
export default Svg035FirstAidCross;